import { useEffect, useState } from "react";
import { ChatHistory } from "../../../types";
import { sendMessage, startChat } from "../../../services/actions";
import { useSessionStorage } from "./use-session-storage";

interface MessageType {
  position: string;
  type: string;
  title: string;
  text: string;
  userType: string;
}

interface UseMessagesReturnType {
  messages: MessageType[];
  setMessages: React.Dispatch<React.SetStateAction<MessageType[]>>;
  isLoadingMessage: boolean;
  setIsLoadingMessage: React.Dispatch<React.SetStateAction<boolean>>;
  session: string;
  setSession: React.Dispatch<React.SetStateAction<string>>;
  isActive: boolean;
  reset: Function;
}

interface useChatParams {
  countryId: number;
  affiliateId: number;
}

const useChat = ({countryId, affiliateId}: useChatParams): UseMessagesReturnType => {
  const [session, setSession] = useSessionStorage('key', '');
  const [isLoadingMessage, setIsLoadingMessage] = useState<boolean>(true);
  const [messages, setMessages] = useState<MessageType[]>([]);
  // is the chat active, false if the conversation has ended
  const [isActive, setIsActive] = useState<boolean>(true);
  
  useEffect(() => {
    start(session);
  }, []);

  useEffect(() => {
    if(isLoadingMessage && messages.length > 0) {
      let latestMessage = messages[messages.length - 1];
      const response = sendMessage({sessionId: session, message: latestMessage.text});
      response.then((response) => {
        setMessages([...messages, {
          position: 'left',
          type: 'text',
          title: 'assistant',
          text: response['Message'],
          userType: 'assistant',
        }]);
        setIsLoadingMessage(false);

        handleAction(response['Action']);
      })
      .catch((error) => {
        console.log(error);
        setIsActive(false);
        // setChatHistory([]);
        // setMessages([]);
        // setSession('');
        setIsLoadingMessage(false);
      });
    }

  }, [isLoadingMessage]);

  const handleAction = (action: String) => { 
    switch (action) {
      case "EndConversation": setIsActive(false);
    }
  };

  const start = (currentSessionId: String) => {
    setIsLoadingMessage(true);

    startChat({ countryId: countryId, affiliateId: affiliateId, sessionId: currentSessionId }).then((response) => {
      setSession(response.SessionId);
      setMessages(response.ChatHistory.map((message: ChatHistory) => ({
        position: message.Sender.Label === 'user' ? 'right' : 'left',
        type: 'text',
        title: message.Sender.Label,
        text: message.ChatDisplayedContent,
        userType: message.Sender.Label.toLowerCase()
      })));

      setIsLoadingMessage(false);
    })
  };

  const reset = () => {
    setSession('');
    setMessages([]);
    setIsActive(true);
    start('');
  };

  // useEffect(() => {

  //     const mappedMessages = chatHistory.map((message) => ({
  //       position: message.Sender.Label === 'user' ? 'right' : 'left',
  //       type: 'text',
  //       title: message.Sender.Label,
  //       text: message.Content,
  //       userType: message.Sender.Label.toLowerCase(),
  //     })) || [];

  //     setMessages(mappedMessages);
  // }, [chatHistory]);

  return { messages, setMessages, session, setSession, isLoadingMessage, setIsLoadingMessage, isActive, reset };
}

export default useChat;